<div class="main-heading">
    <strong translate>EMPLOYEE
        <span> {{ employeeName }}</span>
    </strong>
</div>
<ecpl-tab-navigation [linkItems]="enabledAdditionalFeatures" [parentId]="employeeId" parentKey="EMPLOYEE"
  [linkAccess]="rightsData "></ecpl-tab-navigation>